import { Admin_Dashboard_Daily_Leave_Application } from './admin-dashboard-daily-leave-application.model';
import { ApiErrorCode } from '../service-proxies';


export class Admin_Dashboard_Daily_Leave_ApplicationListApiResponse implements IAdmin_Dashboard_Daily_Leave_ApplicationListApiResponse {
    isSuccess!: boolean;
    responseData!: Admin_Dashboard_Daily_Leave_Application[] | undefined;
    errorCode!: ApiErrorCode;
    errorMessage!: string | undefined;
    errorTitle!: string | undefined;

    constructor(data?: IAdmin_Dashboard_Daily_Leave_ApplicationListApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(Admin_Dashboard_Daily_Leave_Application.fromJS(item));
            }
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTitle = _data["errorTitle"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Daily_Leave_ApplicationListApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Daily_Leave_ApplicationListApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item.toJSON());
        }
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorTitle"] = this.errorTitle;
        return data; 
    }
}

export interface IAdmin_Dashboard_Daily_Leave_ApplicationListApiResponse {
    isSuccess: boolean;
    responseData: Admin_Dashboard_Daily_Leave_Application[] | undefined;
    errorCode: ApiErrorCode;
    errorMessage: string | undefined;
    errorTitle: string | undefined;
}

